module.exports = __webpack_public_path__ + "img/mapLogo.b0a38214.png";